// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Wm-z","innerTile":"Xm-z","heading":"Ym-z","instaTileBtn":"Zm-z","disabled":"_m-z","instaTileElement":"an-z","instagramPic":"bn-z"};